"use client";

import { FC } from "react";
import { useTranslations } from "next-intl";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import classNames from "classnames";

import { IconType } from "@types";

import { Button } from "components/atoms/Button/Button";

import s from "./ToggleView.module.scss";

interface Props {
  view1: React.ReactNode;
  view2: React.ReactNode;
}

export const ToggleView: FC<Props> = ({ view1, view2 }) => {
  const t = useTranslations("search");
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const view = searchParams.get("view") ?? "list";

  const setActiveView = (newView: "list" | "map") => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("view", newView);
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  return (
    <div className={s.ToggleView}>
      <div className={s.ButtonsWrapper}>
        <div className={s.Buttons}>
          <Button
            label={t("list-view")}
            theme={view === "list" ? "dark" : "none"}
            onClick={() => setActiveView("list")}
            icon={IconType.List}
            iconSize="l"
            preIcon
          />
          <Button
            label={t("map-view")}
            theme={view === "map" ? "dark" : "none"}
            onClick={() => setActiveView("map")}
            icon={IconType.Map}
            iconSize="l"
            preIcon
          />
        </div>
      </div>
      {view === "list" && (
        <div
          className={classNames(s.View1, {
            [s.IsVisible]: view === "list",
          })}
        >
          {view1}
        </div>
      )}
      {view === "map" && (
        <div
          className={classNames(s.View2, {
            [s.IsVisible]: view === "map",
          })}
        >
          {view2}
        </div>
      )}
    </div>
  );
};
